<template>
	<div class="wpcm-amount-box">	
		<div class="wpcm-donation-amt-fields">
			<div
				class="el-custom-select"
				v-if="show_currency_dropdown && currencies"
			>
				<el-select
					class="w-100"
					:value="currency"
					@change="setValue('currency', $event)"
				>
					<el-option
						:value="key"
						:key="key"
						:label="curr"
						v-for="(curr, key) in currencies"
						>{{ curr }}</el-option
					>
				</el-select>
			</div>
      <slot name="donation_dropdowns"></slot>
			<div class="" v-if="strings">
				<strong class="wpcm-cstm-amt-txt">{{
					strings.how_much
				}}</strong>
			</div>
      <ul class="wpcm-pre-dfind-amt" v-if="show_amounts && amounts">
        <li
          v-for="amnt in amounts"
          :key="amnt"
          @click.prevent="store.amount = convert(amnt)"
        >
          <a
            href="#"
            :class="[
              'wpdonation-button',
              store.amount == amnt && 'active'
            ]"
          >
            {{ getSymbol() }}{{ amnt }}</a
          >
        </li>
      </ul>
      
    </div>
	</div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useDonationFormsStore } from '../../store';

const store = useDonationFormsStore();
const {amount, currency, recurring } = store;
const props = defineProps([
  "currencies",
  "amounts",
  "strings",
  "show_currency_dropdown",
  "show_amounts",
  "custom_amount",
  "show_recurring",
  "symbols",
  "symbol",
  "display_amount"
]);
const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const setValue = (key, val) => {
  store[key] = val;
};
const getSymbol = () => {
  return (props.symbols[store.currency] != undefined) ? props.symbols[store.currency] : props.symbol
};
const convert = (amt: number) => {
  const { exchange_rates } = lifeline_donation
  const syb = store.currency

  if(_.get(exchange_rates, syb)) {
    return (_.get(exchange_rates, syb) * amt).toFixed(2);
  }
  return amt
};


onMounted(() => {
  if(props.show_amounts && _.size(props.amounts)) {
    setValue('amount', props.amounts[0])
  }
  if(props.show_currency_dropdown && _.size(props.currencies)) {
    setValue('currency', _.keys(props.currencies)[0])
  }
  if (props.display_amount) {
    store.amount = props.display_amount;
  }
});


</script>
